import * as action_types from "./constants";

export type MyCompanyState = {
  companiesList: {
    loading: boolean;
    count: number;
    data: [];
  };
};

const initialState: MyCompanyState = {
  companiesList: {
    loading: true,
    count: 0,
    data: [],
  },
};

export default (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case action_types.COMPANIES_LIST:
      return {
        ...state,
        companiesList: {
          count: data?.count,
          data: data?.data,
          loading: action?.data?.loading,
        },
      };

    default:
      return state;
  }
};
